export enum SOURCE_SAMPLE {
  SPOTIFY = "spotify",
  YOUTUBE = "youtube",
  MANUALLY = "manually",
}
